import { request } from "utils/legacy_api";

export function getByQuestion(questionnaireId, filters) {
  const { institution, year, examNumber } = filters;
  return request(
    `/questionnaire_answers/by_question/${questionnaireId}/${institution}/${year}/${examNumber}`,
    {
      method: "GET"
    }
  );
}

export function update(answerId, attributes) {
  return request(`/questionnaire_answers/${answerId}`, {
    method: "PATCH",
    body: attributes
  });
}
